export function toSentenceCase(value: string | null | undefined): string | null {
    if (value === null) return null;
    if (typeof value !== 'string') {
        throw new TypeError('value is not a string');
    }

    if (value.length === 0) {
        return value;
    }

    return value[0].toUpperCase() + value.slice(1).toLowerCase();
}
